import {
	calculateTotalAmount,
	calculateSubtotal,
	checkoutStatusTypes,
} from "utils";

export const mapCartToCreateCheckoutInput = (model, customerId) => {
	const {
		cartId,
		cartLineItems,
		customer: { email, address },
	} = model;
	address.customerId = customerId;
	const subtotalPrice = calculateSubtotal(cartLineItems);

	const checkout = {
		customerId,
		email,
		subtotalPrice,
		totalPrice: subtotalPrice,
		step: 2,
		checkoutLineItems: {
			create: cartLineItems.map((cartItem) => ({
				variantId: cartItem.variantId,
				quantity: cartItem.quantity,
			})),
		},
	};

	if (address.id) {
		checkout.shippingAddressId = address.id;
	} else {
		checkout.customerAddress = {
			create: { ...address, id: undefined },
		};
	}

	return {
		patch: {
			checkout: {
				create: checkout,
			},
		},
		id: cartId,
	};
};

export const mapToUpdateCheckoutInput = (model) => {
	const {
		checkout,
		customer: { email, address },
	} = model;

	const {
		checkoutId,
		customer: { id },
	} = checkout;

	const out = {
		id: checkoutId,
		patch: {
			email,
			...buildCheckout(checkout),
		},
	};

	if (!address.id) {
		out.patch.customerAddress = {
			create: { ...address, id: undefined },
		};
	}

	if (id) {
		out.patch.customer = {
			updateById: {
				patch: {
					firstName: address.firstName,
					lastName: address.lastName,
					email,
				},
				id,
			},
		};
	}

	return out;
};

export const mapToCreateShippingRateInput = (checkout) => {
	const { checkoutId, shipping, checkoutLineItems } = checkout;
	return {
		patch: {
			step: 3,
			...buildCheckout(checkout),
			shippingRate: {
				create: {
					serviceId: shipping.serviceId,
					price: shipping.rate,
					title: shipping.serviceName,
					serviceType: shipping.serviceType,
				},
			},
			checkoutLineItems: {
				updateById: mapLineItemsToUpdateLineItems(checkoutLineItems),
			},
		},
		id: checkoutId,
	};
};

export const mapToCreatePaymentMethodInput = (model) => {
	const { checkout, paymentMethod } = model;

	const {
		checkoutId,
		customer: { id: customerId },
	} = checkout;
	const { paymentMethodId, card, address } = paymentMethod;

	const out = {
		patch: {
			...buildCheckout(checkout),
		},
		id: checkoutId,
	};

	if (paymentMethodId) {
		out.patch.paymentMethodId = paymentMethodId;
	} else {
		const paymentMethod = {
			externalId: "",
			customerId,
			creditCard: {
				create: card,
			},
		};
		out.patch.paymentMethod = {
			create: paymentMethod,
		};

		if (address.id) {
			paymentMethod.addressId = address.id;
		} else {
			paymentMethod.customerAddress = {
				create: { ...address, customerId },
			};
		}
	}

	return out;
};

export const mapToCheckoutModel = (checkout, checkoutId) => {
	const {
		customerId,
		shippingAddress: { __typename, ...shippingAddress },
		shippingRate,
		checkoutLineItems,
		...rest
	} = checkout;

	const out = {
		checkoutId,
		...rest,
		customer: {
			id: customerId,
			email: rest.email,
			address: shippingAddress,
		},
		shipping: {
			rate: 0,
		},
		checkoutLineItems: checkoutLineItems.nodes.map(
			({ __typename, ...lineItem }) => lineItem
		),
	};

	if (shippingRate) {
		out.shipping = {
			id: shippingRate.id,
			classId: shippingRate.handle,
			rate: shippingRate.price,
			mailService: shippingRate.title,
		};
	}

	return out;
};

const buildCheckout = (checkout) => {
	const { subtotalPrice, totalTax, totalDiscounts, shipping } = checkout;
	return {
		subtotalPrice,
		totalTax,
		totalDiscounts,
		totalPrice: calculateTotalAmount(
			subtotalPrice,
			totalTax,
			totalDiscounts,
			shipping
		),
	};
};

const mapLineItemsToUpdateLineItems = (lineItems) => {
	return lineItems.map((lineItem) => ({
		id: lineItem.id,
		patch: {
			tax: lineItem.tax,
			taxRate: lineItem.taxRate,
		},
	}));
};
